/**
 * plus メニューのラベルを組み立てる【#524】
 *
 * ブランド名の出どころを SYSTEMTITLE（hm99_system_parameters の function_id='TEXT'）に
 * 一本化し、サフィックスだけ PLUS_MENU_SUFFIX で可変にする。ブランド名をフル文字列で
 * 別に持つと、ブラウザタブ・ハンバーガー先頭・メニュー名の 3 箇所が食い違いうるため持たせない。
 *
 * PLUS_MENU_SUFFIX が未登録の会社は現行のラベルを維持する
 * （RecViewer=true は「RecViewer設定」、それ以外は言語ファイルの「RecACEplus設定」）。
 *
 * company_options.RecViewer は「スマホアプリ RecViewer の提供有無」（#292）であり、
 * ラベルのために書き換えてはいけない。
 *
 * Header 本体から切り出しているのはテストのため。Header を import すると
 * AscComponent 経由で axios まで引き込むため、ラベルだけを検証できない。
 *
 * @param {object} systemParameters Sign/getSystemParameterByType の応答
 * @param {object} langText 言語ファイル（langText.Header を参照する）
 * @param {object} companyOptions userInfo.company_options
 * @returns {string} メニューに出すラベル
 */
export const buildPlusMenuLabel = (systemParameters, langText, companyOptions) => {
    const params = systemParameters || {};
    const options = companyOptions || {};
    const header = (langText && langText.Header) || {};

    if (params.PLUS_MENU_SUFFIX && params.SYSTEMTITLE) {
        return `${params.SYSTEMTITLE}${params.PLUS_MENU_SUFFIX}`;
    }
    return options.RecViewer ? header.RecViewer : header.RecACEPlus;
};
